/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Short_Item_4Inputs */



/**
* | output |
* | --- |
* | "This is not a substitute for comprehensive compliance measures." |
*
* @param {Guardrails_Short_Item_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_short_item_4 = /** @type {((inputs?: Guardrails_Short_Item_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Short_Item_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Ersatz für umfassende Compliance-Maßnahmen")
	return /** @type {LocalizedString} */ ("This is not a substitute for comprehensive compliance measures.")
});